export const CALIBRATION_TYPE = {
  INITIAL: 'initial',
  RECALIBRATION: 'recalibration',
} as const;

export type CalibrationType = typeof CALIBRATION_TYPE[keyof typeof CALIBRATION_TYPE];
